// src/pages/InvoiceNew.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiRequest } from "../api";

const input = {
  padding: 8,
  borderRadius: 8,
  border: "1px solid #ddd",
  width: "100%",
};

export default function InvoiceNew() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("job_id");
  const urlClientId = searchParams.get("client_id");

  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState("");
  const [jobDetail, setJobDetail] = useState(null);

  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      setErr("");

      try {
        if (jobId) {
          const jobResult = await apiRequest(`/jobs/${jobId}/detail`);
          setJobDetail(jobResult);

          const jobClient = jobResult?.client;
          if (jobClient && jobClient.id) {
            setClients([jobClient]);
            setClientId(String(jobClient.id));
          } else {
            setClients([]);
            setClientId("");
            setErr("Project loaded, but no client was found.");
          }
        } else {
          const clientsResult = await apiRequest("/clients/");
          const clientList = Array.isArray(clientsResult) ? clientsResult : [];
          setClients(clientList);

          if (urlClientId) {
            setClientId(String(urlClientId));
          } else if (clientList.length > 0) {
            setClientId(String(clientList[0].id));
          } else {
            setClientId("");
          }
        }
      } catch (e) {
        setErr(e.message || "Failed to load invoice form.");
      } finally {
        setLoading(false);
      }
    })();
  }, [jobId, urlClientId]);

  async function create() {
    if (!clientId) {
      setErr("Please select a client.");
      return;
    }

    setCreating(true);
    setErr("");

    try {
const payload = {
  client_id: Number(clientId),
  items: [],
  ...(jobId ? { job_id: Number(jobId) } : {}),
};

      const inv = await apiRequest("/invoices", {
        method: "POST",
        body: payload,
      });

      navigate(`/invoices/${inv.id}`, { replace: true });
    } catch (e) {
      setErr(e.message || "Create failed.");
    } finally {
      setCreating(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  return (
    <div style={{ padding: 24, maxWidth: 700, margin: "0 auto" }}>
      <div style={{ marginBottom: 12 }}>
        <Link to="/invoices">← Back to Invoices</Link>
      </div>

      <h2>Create Invoice</h2>

      {err && <div style={{ color: "crimson", marginBottom: 10 }}>{err}</div>}

      {!jobId && (
        <div
          style={{
            border: "1px solid rgba(224,184,79,0.45)",
            borderRadius: 10,
            padding: 14,
            marginBottom: 14,
            background: "rgba(224,184,79,0.10)",
            color: "#5c4300",
          }}
        >
          <div style={{ fontWeight: 800, marginBottom: 6 }}>
            Want this invoice connected to a project?
          </div>

          <div style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 10 }}>
            For project tracking, ledger history, receipts, and job notes, create the invoice from the Project / Job Detail page.
          </div>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => navigate("/jobs")}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "none",
                cursor: "pointer",
                background: "#1d4ed8",
                color: "#ffffff",
                fontWeight: 700,
              }}
            >
              Go to Jobs
            </button>

            <span style={{ fontSize: 13, alignSelf: "center", color: "#6b7280" }}>
              Or continue below without linking this invoice to a project.
            </span>
          </div>
        </div>
      )}

      <div style={{ display: "grid", gap: 10, maxWidth: 480 }}>
        <label>
          <div style={{ marginBottom: 4 }}>Client</div>
          <select
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            style={input}
          >
            {clients.map((c) => (
              <option key={c.id} value={c.id}>
                {c.company_name || c.contact_name || `Client #${c.id}`}
              </option>
            ))}
          </select>
        </label>

        <div>
          <button
            onClick={create}
            disabled={creating}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: 0,
              background: "#111",
              color: "#fff",
            }}
          >
            {creating ? "Creating…" : "Create Draft"}
          </button>
        </div>
      </div>
    </div>
  );
}
